import { Channel } from '@g99-product-web-ui/shared-interface-lib';

import { HELP_DOCS } from './helpcenter-link.const';
import {
  demandforceIcon,
  facebookIcon,
  googleIcon,
  yelpIcon,
} from '../icons/icon.constants';
import { ROUTE_CONSTS } from '../routes/routes.constants';

// personalization  colors

export const PERSONALIZATION_APPERANCE_COLORS = [
  '#1F1F21',
  '#7939EF',
  '#434CE7',
  '#165EF0',
  '#2E90FB',
  '#7F8DDA',
  '#5D6DBD',
  '#465B68',
  '#526456',
];

export const WHITE_COLOR = '#ffffff';
export const BLACK_COLOR = '#000000';

export enum ReviewConfigTypeEnum {
  SINGLE_LOCATION = 'single-location',
  MULTI_LOCATION = 'multi-location',
  ALL_REVIEWS = 'all-reviews',
  CAROUSEL_REVIEW = 'carousel-review',
  CAROUSEL_REVIEW_NEW_LAYOUT = 'carousel-review-new-layout',
  FLOATING_REVIEW = 'floating-review',
}

export const PREVIEW_POP_DROPDOWN_OPTIONS = [
  {
    name: 'Website Configuration Code - Single Location',
    reviewConfigType: ReviewConfigTypeEnum.SINGLE_LOCATION,
  },
  {
    name: 'Website Configuration Code - Multi Location',
    reviewConfigType: ReviewConfigTypeEnum.MULTI_LOCATION,
  },
  {
    name: 'Website Configuration Code - All Location',
    reviewConfigType: ReviewConfigTypeEnum.ALL_REVIEWS,
  },
  {
    name: 'Website Configuration Code - Carousel Widget',
    reviewConfigType: ReviewConfigTypeEnum.CAROUSEL_REVIEW,
  },
  {
    name: 'Website Configuration Code - Carousel Widget New Layout',
    reviewConfigType: ReviewConfigTypeEnum.CAROUSEL_REVIEW_NEW_LAYOUT,
  },
  {
    name: 'Website Configuration Code - Floating Reviews',
    reviewConfigType: ReviewConfigTypeEnum.FLOATING_REVIEW,
  },
];

export const SETUP_DESTINATION_FIELDS_OPTIONS = [
  {
    label: 'Google',
    modelBinding: 'googleChecked',
    inputFields: ['Google My Business URL', 'Google Place Id'],
    inputValues: ['', ''],
  },
  {
    label: 'Facebook',
    modelBinding: 'facebookChecked',
    inputFields: ['Facebook Review URL'],
    inputValues: [''],
  },
  {
    label: 'Yelp',
    modelBinding: 'yelpChecked',
    inputFields: ['Yelp Review URL'],
    inputValues: [''],
  },
  {
    label: 'DemandForce',
    modelBinding: 'demandForceChecked',
    inputFields: ['Demand Force Review URL'],
    inputValues: [''],
  },
];

export const SETUP_DESTINATION_STARS_DROPDOWN_OPTIONS = [
  { name: '1 stars and more', value: 'ONEANDMORE' },
  { name: '2 stars and more', value: 'TWOANDMORE' },
  { name: '3 stars and more', value: 'THREEANDMORE' },
  { name: '4 stars and more', value: 'FOURANDMORE' },
  { name: '5 stars', value: 'FIVE' },
];

export const BUSINESS_LOGO_URL = {
  BUSINESS_LOGO_URL:
    'https://g99plus.b-cdn.net/AEMR/assets/img/growth99_icon.png',
  BUSINESS_AGENCY_URL:
    'https://g99plus.b-cdn.net/AA%20new%20g99%20app/images/g99%20full%20logo.svg',
};

export const LOCATIONS_DEFAULT_FILTERS = [
  {
    id: -1,
    location: 'All Locatons',
  },
];

export const HIDE_UNHIDE_FILTER_VALUE = [
  {
    tag: 'All',
    value: 'all',
  },
  {
    tag: 'Hide',
    value: 'hide',
  },
  {
    tag: 'Unhide',
    value: 'unhide',
  },
];

export const PLATFORM_STATES = {
  googleChecked: false,
  facebookChecked: false,
  yelpChecked: false,
  demandforceChecked: false,
};

export const HEADER_MENU = [
  {
    id: 1,
    name: 'Locations',
    notification: null,
    path: ROUTE_CONSTS.REVIEWS.location,
  },
  {
    id: 2,
    name: 'Feedback',
    notification: null,
    path: ROUTE_CONSTS.REVIEWS.feedbacklist,
  },
  {
    id: 3,
    name: 'Reviews',
    notification: null,
    path: ROUTE_CONSTS.REVIEWS.reviewlist,
  },
];

export const DOWNLOAD_QR_OPTIONS = [
  {
    icon: '<img alt="PDF logo"  color="black" src="assets/DownloadGrey.svg" />',
    label: 'PNG',
    type: 'png',
    fileSize: '15MB',
  },
  {
    icon: '<img alt="PDF logo"  color="black" src="assets/DownloadGrey.svg" />',
    label: 'IMG',
    type: 'jpeg',
    fileSize: '20MB',
  },
  {
    icon: '<img alt="PDF logo"  color="black" src="assets/DownloadGrey.svg" />',
    label: 'SVG',
    type: 'svg',
    fileSize: '55MB',
  },
];

export const DEFAULT_REVIEW_PROMPT_DATA = {
  clinicId: '0',
  pageTitle: 'Rate your experience',
  pageDesc: 'Please rate your experience with us on scale from 0 to 10',
  redirectReviewFormRating: 7,
  negativeFeedBackText: 'My experience wasn’t good….',
  positiveFeedBackText: 'My experience was good...',
};

export const REVIEW_STATISTICS_FILTER_VALUES = {
  oneMonth: 'ONEMONTH',
  threeMonth: 'THREEMONTH',
  sixMonth: 'SIXMONTH',
};

export const HTML_DATA_CONTENT = {
  shareIcon: '<i class="pi pi-upload"></i>',
  upArrowIcon:
    '<i class="pi pi-arrow-up-right" style="font-size: 12px;   width: 9px; height: 9px;"></i>',
  downArrowIcon: '<img alt="PDF logo" src="assets/DownArrow.svg" />',
  downloadIcon: '<img alt="PDF logo" src="assets/Download.svg" />',
  pdfDownloadIcon:
    '<img alt="PDF logo"  color="black" src="assets/DownloadGrey.svg" />',
};

export const LOCATION_HEADER_MENU = [
  'Customise Review Prompt',
  // 'Setup Feedback Form',
  'Setup Review Destination',
];

export const PREVIEW_POPUP_CONSTANTS = {
  previewPopUpTitle: "You're All Set!",
  brochurePdfName: 'Brochure.pdf',
};

export const RATING_BUTTONS_DATA = [
  { name: '4 and above', value: 4 },
  { name: '5 and above', value: 5 },
  { name: '6 and above', value: 6 },
  { name: '7 and above', value: 7 },
  { name: '8 and above', value: 8 },
  { name: '9 and above', value: 9 },
  { name: '10', value: 10 },
];

export const REVIEW_MANAGER_REGEX = {
  review_manager_clinic_adress_regex: /,\s*([^,]+),/,
};

export const PREVIVE_POPUP_CSS = {
  REVIEW_INTEGRATION_COPY_COMPONENT: {
    INPUT_COPY_TEXT_AREA: {
      'border-radius': '0px 0px 10px 10px',
      'border-top': 'none',
      'background-color': '#F3F5F9',
      'font-weight': '400',
      'font-size': '14px',
      'line-height': '19.6px',
      color: '#4C5661',
    },
    COPY_ICON: {
      'border-radius': '0 0px 10px 0',
      'background-color': '#E8EBF0',
    },
    SPAN_STYLE: { 'font-size': '14px' },
  },
  FEEDBACK_FORM_INTEGRATION_COPY_COMPONENT: {
    INPUT_COPY_TEXT_AREA: {
      'min-height': '40px',
      'background-color': '#F3F5F9',
      'font-weight': '400',
      'font-size': '14px',
      'line-height': '19.6px',
      color: '#4C5661',
    },
    COPY_ICON: {
      'min-height': '40px',
      'background-color': '#E8EBF0',
    },
    SPAN_STYLE: { 'font-size': '14px' },
  },
};

export const DAYS_PIPE_INTERVAL = {
  year: 31536000,
  month: 2592000,
  week: 604800,
  day: 86400,
  hour: 3600,
  minute: 60,
  second: 1,
};

export const DUE_DATE_MESSAGES = {
  DAYS_OVERDUE: ' DAY OVERDUE',
};

export const BUSINESS_NOTIFICATION_ERROR_MESSAGES = {
  notificationEmail: {
    pattern: 'Please enter a valid notification email address',
  },
};

export const BUSINESS_DOMAIN_ERROR_MESSAGES = {
  domain: {
    required: 'Domain is required',
    pattern: 'Please enter a valid domain',
  },
};

export const PERSONALIZATION_ERROR_MESSAGES = {
  foregroundButton: {
    required: 'Foreground Button is required',
    pattern: 'Invalid Hex code',
  },
  backgroundButton: {
    required: 'Background Button is required',
    pattern: 'Invalid Hex code',
  },
  titleColor: {
    required: 'Title Color is required',
    pattern: 'Invalid Hex code',
  },
};

export const REVIEW_PLATFORM: Channel[] = [
  {
    id: 'google',
    name: 'Google',
    icon: 'G',
    imageUrl: googleIcon,
    selected: true,
    title: 'Google Business Profile',
    subTitle: 'Connect your Google business listings',
    infoLink: HELP_DOCS.REVIEW_MANAGER.GOOGLE_PROFILE_ID,
    label: 'Google Profile ID',
    required: false,
    reviewCount: 0,
    reviewStatus: '',
  },
  {
    id: 'facebook',
    name: 'Facebook',
    icon: 'f',
    imageUrl: facebookIcon,
    selected: false,
    title: 'Facebook URL',
    subTitle: 'Add your facebook review URL',
    infoLink: HELP_DOCS.REVIEW_MANAGER.FACE_BOOK_SETUP,
    label: 'Facebook URL',
    required: false,
    reviewCount: 0,
    reviewStatus: '',
  },
  {
    id: 'yelp',
    name: 'Yelp',
    icon: 'Y',
    imageUrl: yelpIcon,
    selected: false,
    title: 'Yelp URL',
    subTitle: 'Add your yelp review URL',
    infoLink: HELP_DOCS.REVIEW_MANAGER.YELP_SETUP,
    label: 'Yelp URL',
    required: false,
    reviewCount: 0,
    reviewStatus: '',
  },
  {
    id: 'demandforce',
    name: 'DemandForce',
    icon: 'D',
    imageUrl: demandforceIcon,
    selected: false,
    title: 'Demandforce URL',
    subTitle: 'Add your demandforce review URL',
    infoLink: HELP_DOCS.REVIEW_MANAGER.DEMAND_FORCE_SETUP,
    label: 'Demandforce URL',
    required: false,
    reviewCount: 0,
    reviewStatus: '',
  },
];

export const REVIEW_CONFIGURATION_ERROR_MESSAGES = {
  facebook: {
    pattern: 'Entered URL is not valid',
  },
  yelpUrl: {
    pattern: 'Entered URL is not valid',
  },
  demandforceUrl: {
    pattern: 'Entered URL is not valid',
  },
  google: {
    pattern: 'Value must be in digit',
  },
};

export const PLATFORMS = {
  facebook: 'facebook',
  google: 'google',
  demandforce: 'demandforce',
  yelp: 'yelp',
};
